export const myDescription =
  "En reconversion dans le domaine du développement Web et Web mobile, j'ai effectué une formation intensive à la Wild Code School, école spécialisée dans le numérique dans laquelle j'ai fait mes premières armes en Javascript (React / NodeJs). À la suite de mon stage dans l'agence Bluesquare.io, et après avoir obtenu mon titre professionnel, j'ai suivi une nouvelle formation de 3 mois en PHP / Symfony à Simplon.co. Je souhaite à présent réaliser une alternance afin de passer le titre de concepteur/développeur d'applications, ce qui me permettra d'acquérir une expérience suffisante pour démarrer ma nouvelle carrière de développeur.";

export const steps = [
  {
    start: "Mai 2021",
    end: "Août 2021",
    company: "Simplon.co",
    companyUrl: "https://simplon.co/",
    companyTechnos: ["php", "Symfony"],
    title: "Formation développeur back-end PHP Symfony",
    type: "formation",
    missions: []
  },
  {
    start: "Mars 2021",
    end: "",
    company: "",
    companyUrl: "",
    companyTechnos: [],
    title: "Obtention du titre de développeur Web / Web Mobile",
    type: "diplôme",
    missions: []
  },
  {
    start: "Septembre 2020",
    end: "Décembre 2020",
    company: "Bluesquare.io",
    companyUrl: "https://bluesquare.io/",
    companyTechnos: [],
    title: "Développeur Web / Web Mobile (stage)",
    type: "stage",
    missions: [
      {
        description: "Refonte d'un site français reconnu de chasseur de têtes",
        technos: ["Laravel", "ReactJS", "SCSS"],
        features: [
          "Implémenter de nouvelles fonctionnalités dynamiques en React",
          "Créer des animations",
          "Améliorer et déboguer l'interface graphique"
        ]
      },
      {
        description: "Développer un centre d'aide pour les clients de l'agence",
        technos: ["PHP", "VueJS", "Laravel", "InertiaJS", "TailwindCSS"]
      }
    ]
  },
  {
    start: "Mars 2020",
    end: "Juillet 2020",
    company: "Wild Code School",
    companyUrl: "https://www.wildcodeschool.com/fr-FR",
    companyTechnos: ["Javascript", "ReactJS", "NodeJS"],
    title: "Formation développeur Web / Web Mobile",
    type: "formation",
    missions: []
  }
];
